export const SET_SERVICEDTO = "REGISTERSERVICES/SET_SERVICEDTO";
